/* eslint-disable */
/* tslint-disable */
import { attr, Component, handler } from '../Component'
import { element } from '../CustomElement'
import { i18n } from '../../i18n/I18n'

export interface Option {
    name: string
    value: string
}

interface DropdownProps extends JSX.HTMLProps {
    options: string
    handleItemSelected: (item: string) => void
}

@element('flipp-dropdown')
export class Dropdown extends Component<DropdownProps, any> {
    @attr options: string
    @handler handleItemSelected: (item: string) => void

    onAttach() {
        this._initDropdown()
    }

    onAttributeChange(name: string) {
        if (name === 'options') {
            this.invalidate()
            const select = document.getElementsByTagName('select')[0]
            if (select) {
                select.selectedIndex = 0
                setTimeout(() => {
                    this._removeDropdown()
                    this._initDropdown()
                })
            }
        }
    }

    render() {
        const options = JSON.parse(this.options) as Option[]
        return (
            <div class="custom-select">
                <select name="residentOf">
                    <option value="0">{i18n('my_data_select_option')}</option>
                    {options.map((item) => {
                        return <option value={item.value}>{item.name}</option>
                    })}
                </select>
            </div>
        )
    }

    private _handleSelectedItemClick(a: any) {
        this._closeAllSelect(this)
        ;(a.nextSibling as any).classList.toggle('select-hide')
        this.classList.toggle('select-arrow-active')
    }

    private _handleSelectItemClick(c: any) {
        let y, i, k, s, h, sl, yl
        s = document.getElementsByTagName('select')[0]
        sl = s.length
        h = c.parentNode.previousSibling
        for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML === c.innerHTML) {
                s.selectedIndex = i
                this.handleItemSelected(s.options[i].getAttribute('value'))
                ;(h as any).innerHTML = c.innerHTML
                y = document.getElementsByClassName('same-as-selected')
                yl = y.length
                for (k = 0; k < yl; k++) {
                    y[k].removeAttribute('class')
                }
                this.setAttribute('class', 'same-as-selected')
                break
            }
        }
        ;(h as any).click()
    }

    private _closeAllSelect(elmnt: any) {
        let x,
            y,
            i,
            xl,
            yl,
            arrNo = []
        x = document.getElementsByClassName('select-items')
        y = document.getElementsByClassName('select-selected')
        xl = x.length
        yl = y.length
        for (i = 0; i < yl; i++) {
            if (elmnt === y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove('select-arrow-active')
            }
        }
        for (i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add('select-hide')
            }
        }
    }

    private _initDropdown() {
        let x, i, j, l, ll, selElmnt, b
        x = document.getElementsByClassName('custom-select')
        l = x.length
        for (i = 0; i < l; i++) {
            selElmnt = x[i].getElementsByTagName('select')[0]
            ll = selElmnt.length
            const a = document.createElement('DIV')
            a.setAttribute('class', 'select-selected')
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML
            x[i].appendChild(a)
            b = document.createElement('DIV')
            b.setAttribute('class', 'select-items select-hide')
            for (j = 1; j < ll; j++) {
                const c = document.createElement('DIV')
                c.innerHTML = selElmnt.options[j].innerHTML
                c.addEventListener('click', (e) => {
                    this._handleSelectItemClick(c)
                })
                b.appendChild(c)
            }
            x[i].appendChild(b)
            a.addEventListener('click', (e) => {
                e.stopPropagation()
                this._handleSelectedItemClick(a)
            })
        }
        document.addEventListener('click', this._closeAllSelect)
    }

    private _removeDropdown() {
        let x, i, l
        x = document.getElementsByClassName('select-selected')
        l = x.length
        for (i = 0; i < l; i++) {
            x[0].removeEventListener(
                'click',
                (e) => this._handleSelectedItemClick
            )
            x[0].remove()
        }
        x = document.getElementsByClassName('select-items')
        l = x.length
        for (i = 0; i < l; i++) {
            const d = x[0].getElementsByTagName('div')
            for (i = 0; i < d.length; i++) {
                d[0].removeEventListener(
                    'click',
                    (e) => this._handleSelectItemClick
                )
            }
            x[0].remove()
        }
        document.removeEventListener('click', this._closeAllSelect)
    }
}
